<template>
	<div class="text-justify">
		<app-tab
			ref="horizontalTabRef"
			:tabs="tabs"
			type="horizontal"
			:elevated="false"
			tabClass="px-4 py-3"
		/>
	</div>
</template>

<script>
export default {
	name: "StudentTabPlacement",
	// inject: ['eventHub'],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			studentProfilePlacementSubTabLists: [],
			tabs: [],
		};
	},
	created() {

		// this.eventHub.$emit('bookingOyo', $val);

		// this.eventHub.$on('bookingOyo', $val => {
		// 	console
		// })

		this.studentProfilePlacementSubTabLists = [
			{ id: "placement-booking", function: this.goToPlacementBooking },
			{ id: "class-trial", function: this.goToClassTrial },
			{ id: "placement-test", function: this.goToPlacementTest },
			{ id: "direct-placement", function: this.goToDirectPlacement },
		];

		this.tabs = [
			{
				name: "Placement Booking",
				component: "student-profile-tab-placement-placement-booking",
				permission: "",
				props: {
					value: this.value,
					studentProfilePlacementSubTabLists:
						this.studentProfilePlacementSubTabLists,
				},
			},
			{
				name: "Class Trial",
				component: "student-profile-tab-placement-class-trial",
				permission: "",
				isShow: false,
			},
			{
				name: "Placement Test",
				component: "student-profile-tab-placement-placement-test",
				permission: "",
				isShow: false,
			},
			{
				name: "Direct Placement",
				component: "student-profile-tab-placement-direct-placement",
				permission: "",
				isShow: false,
			},
		];
	},
	methods: {
		goToPlacementBooking(rowData) {
			this.$refs.horizontalTabRef.$children[0].loadTab(
				{
					name: "Placement Booking",
					component: "student-profile-tab-placement-placement-booking",
					permission: "",
					props: {
						rowData: rowData,
					},
				},
				1
			);
		},
		goToClassTrial(rowData) {
			this.$refs.horizontalTabRef.$children[0].loadTab(
				{
					name: "Class Trial",
					component: "student-profile-tab-placement-class-trial",
					permission: "",
					props: {
						rowData: rowData,
					},
				},
				1
			);
		},
		goToPlacementTest(rowData) {
			this.$refs.horizontalTabRef.$children[0].loadTab(
				{
					name: "Placement Test",
					component: "student-profile-tab-placement-placement-test",
					permission: "",
					props: {
						rowData: rowData,
					},
				},
				2
			);
		},
		goToDirectPlacement(rowData) {
			this.$refs.horizontalTabRef.$children[0].loadTab(
				{
					name: "Direct Placement",
					component: "student-profile-tab-placement-direct-placement",
					permission: "",
					props: {
						rowData: rowData,
					},
				},
				3
			);
		},
	},
};
</script>
